import React from "react";
import App from "routes/index";
import { useRouteMatch } from "react-router-dom";
import "react-quill/dist/quill.snow.css"; // ES6
const MainApp = () => {
  const match = useRouteMatch();
  return <App match={match} />;
};
export default MainApp;
